import {Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {formatCurrency} from '@angular/common';
import {InventoryComponent} from "@irb/irb-orders/order-blotter/inventory/inventory.component";
import {UtilityService} from "@irb-common/services/utility.service";
import {
  expTypes,
  orderTypes,
  priceTypes,
  optionOrderTypes,
  UIDropDownBlotter,
  ordNotHeldFillPolicys,
  ordNotHeldIncludeExclude,
  ordNotHeldStyles,
  getAlgorithms,
  getDestinations,
  iLayoutFieldsShowHide
} from './trade-instructions.model';
import { InventoryService } from "@irb/irb-orders/order-blotter/inventory/inventory.service";
import { AlgorithmLayoutSetup } from './edit-trade-service/algorithm-layout-setup.service';
import { GetDestinationQ } from './edit-trade-service/get-destination-q.service';
import { NotHeldLayoutSetup } from './edit-trade-service/not-held-layout-setup.service';
import { orderTypeLayoutSetup } from './edit-trade-service/order-type-layout-setup';
import { SpreadOptionAction } from './edit-trade-service/spread-option-action.service';
import { DestinationInstruction } from './edit-trade-service/destination-instruction.service';
import { TrailingStopOrderTypeFilter } from './edit-trade-service/trailing-stop-order-type-filter.service';
import {UpdateOrder, UpdateOrderPayload} from "@irb/irb-orders/order-blotter/inventory/update-order-payload";
import {
  formatAlgorithmReverse, formatdefaultOrderPriceTypeReverse, formatDestinationsReverse,
  formatExpTypesReverse,
  formatOrderStatusReverse,
  formatOrderTypeReverse,
  formatSecurityTypeReverse,
  formatTransactionReverse
} from "@irb-common/formatters";
import {TooltipService} from "@irb-common/components/tooltip/tooltip.service";
import {NumberTextBoxComponent} from "@irb-common/components/number-text-box/number-text-box.component";
import {itemsVariousVsValue} from "@irb/irb-editors/edit-trading-instructions/trade-instructions/edit-trade-service/items-various-vs-value";
import {IGlobalSettings} from "@irb/irb-dashboard/irb-dashboard.model";
import {IrbSettingsService} from "@irb/irb-settings/irb-settings.service";
import {DropdownFilterComponent} from "@irb-common/components/dropdown-filter/dropdown-filter.component";
import { AppService } from '@irb/app.service';

@Component({ standalone: false,
  selector: "irb-trade-instructions",
  templateUrl: "./trade-instructions.component.html",
  styleUrls: ["./trade-instructions.component.scss"],
})
export class TradeInstructionsComponent implements OnInit {
  isTestMode = false;
  @Input()
  data: any;
  @Input()
  parentObj: InventoryComponent;
  @Input()
  actionType: string = "";
  @Input()
  bidAndAskPrices: any;

  pfs: InventoryService = {} as InventoryService;
  ordNotHeldMaxVolPctRequired = false;

  @ViewChild("ordNotHeldInclude")
  ordNotHeldInclude: ElementRef;
  @ViewChild("blockDeskContact")
  blockDeskContact: ElementRef;
  @ViewChild("expirationDateElem")
  expirationDateElem: ElementRef;
  @ViewChild("ordNotHeldStartTimeElem")
  ordNotHeldStartTimeElem: ElementRef;
  @ViewChild("ordNotHeldEndTimeElem")
  ordNotHeldEndTimeElem: ElementRef;
  @ViewChild("priceElem")
  priceElem: NumberTextBoxComponent;
  @ViewChild("limitPriceElem")
  limitPriceElem: NumberTextBoxComponent;
  @ViewChild("stopPriceElem")
  stopPriceElem: NumberTextBoxComponent;

  @ViewChild("ordNotHeldPartRateElem")
  ordNotHeldPartRateElem: NumberTextBoxComponent;
  @ViewChild("ordNotHeldMaxVolPctElem")
  ordNotHeldMaxVolPctElem: NumberTextBoxComponent;
  @ViewChild("ordNotHeldMaxDispSizeElem")
  ordNotHeldMaxDispSizeElem: NumberTextBoxComponent;
  @ViewChild("ordNotHeldIWPriceElem")
  ordNotHeldIWPriceElem: NumberTextBoxComponent;
  @ViewChild("expirationTypeElem")
  expirationTypeElem: any;
  @ViewChild("notHeldDestinationElem")
  notHeldDestinationElem: any;
  @ViewChild("notHeldAlgorithmElem")
  notHeldAlgorithmElem: any;
  @ViewChild("optionOrderTypeElem")
  optionOrderTypeElem: any;
  @ViewChild("ordNotHeldFillPolicyElem")
  ordNotHeldFillPolicyElem: any;
  @ViewChild("ordNotHeldStyleElem")
  ordNotHeldStyleElem: any;
  @ViewChild("orderTypeElem")
  orderTypeElem: any;

  @ViewChild("includeExcudeElem") includeExcudeElem: any;
  @ViewChild("priceTypesElem") priceTypesElem: any;

  isParent = false;
  okBtnHandler: any; //???
  isResetting = false;
  isModified = false;
  multiItemsVariousVsValue = {};
  blockdeskrecordspresent = false;
  //gridID // not needed
  item: any; //todo: currently it is the same as this.data - remove later and use this.data instead
  multiRecords: any[]; ////IOrders[];

  layoutFieldsShowHide: iLayoutFieldsShowHide;

  orderTypes = orderTypes;
  orderType: string;
  orderTypeSelected: UIDropDownBlotter;
  orderTypesDisabled = false;
  orderTypeTooltipMsg = "";
  changeOrderType = false;
  orderTypePlaceHolder: UIDropDownBlotter;
  isOrderTypePlaceHolder = false;
  orderTypeRemainsVarious = false;

  optionOrderTypes = optionOrderTypes;
  optionOrderType: string;
  optionOrderTypeSelected: UIDropDownBlotter;
  optionOrderTypeDisabled = false;
  optionOrderTypeVisible = false;
  optionOrderTypeTooltipMsg = '';

  optionRecordsPresent = false;

  priceTypes = priceTypes;
  priceTypeSelected: UIDropDownBlotter;
  priceTypeDisabled = false;
  priceTypeVisible = false;
  priceType = '';
  daySixMonthsAfter:string;
  daySixMonthsAfterDisplay: string;

  price: number;
  priceVisible = false;
  priceDisabled = false;
  priceValueVisible = true;
  isShowPriceVarious = false;
  isShowMarketPrice = false;

  priceLabel = 'Price';
  priceConstraints = {
    min: 0,
    max: 1000000000,
    pattern: '######.00',
    places: '2'
  }

  limitPrice: number;
  limitPriceVisible = false;
  limitPriceDisabled = false;
  limitInstructionTextVisible = false;
  isShowLimitPriceVarious = false;

  stopPrice: number;
  stopPriceVisible = false;
  stopPriceDisabled = false;
  isShowStopPriceVarious = false;

  expTypes = expTypes;
  expirationType: string;
  expTypeSelected: UIDropDownBlotter;
  expirationTypeDisabled = false;
  expirationTypeTooltipMsg = '';

  expirationDate: string;
  expirationDateDisabled = false;
  expirationDateTooltipMsg = '';
  isShowExpDateVarious = false;

  notHeldDestinations: any[];
  notHeldDestinationDisabled = true;
  notHeldDestinationSelected: any;
  notHeldDestinationTooltipMsg = '';
  notHeldRefItm = false; //todo: find out what it is

  algorithms: any[];
  algorithmType: string = '';
  algorithmSelected: any;
  algorithmEnabled = false;
  notHeldPermissions = false;
  algorithmPermissionsObj: any = {
    algorithmPermissionsList: null,
    available: false,
  };
  notHeldAlgorithmTooltipMsg = '';

  ordNotHeldFillPolicys = ordNotHeldFillPolicys;
  ordNotHeldFillPolicyDisabled = false;
  ordNotHeldFillPolicySelected: UIDropDownBlotter;
  ordNotHeldFillPolicyTooltipMsg = '';

  ordNotHeldIncludeExclude = ordNotHeldIncludeExclude;
  ordNotHeldIncludeExcludeDisabled = false;
  ordNotHeldIncludeExcludeSelected: UIDropDownBlotter;

  ordNotHeldStyles = ordNotHeldStyles;
  ordNotHeldStyleDisabled = false;
  ordNotHeldStyleSelected: UIDropDownBlotter;
  ordNotHeldStyleTooltipMsg = '';

  notHeld = false;
  notHeldDisabled = false;
  ordNotHeldStyle: ElementRef;
  ordIsNotHeldVarious = 'Various'; // span with text "Various"
  isShowNotHeldVarious = false;
  isSolictedVarious = false;
  isDiscretionaryVarious = false;
  ordNotHeldMinTime = '09:30:00';
  ordNotHeldMaxTime = '16:00:00';
  ordNotHeldStartTime: string;
  ordNotHeldEndTime: string;
  ordNotHeldStartTimeTooltipMsg = "";
  ordNotHeldEndTimeTooltipMsg = "";
  ordNotHeldAuctionOnly = false;

  tomorrowDate: string;
  currentDate = new Date();
  destinationInstructionText = '';

  isSolicited = false;
  isDiscretionary = false;

  ordNotHeldPartRateDisabled = false;
  ordNotHeldPartRateValue: number;
  ordNotHeldMaxVolPctDisabled = false;
  ordNotHeldMaxVolPctValue: number;
  ordNotHeldMaxDispSizeDisabled = false;
  ordNotHeldMaxDispSizeValue: number;
  ordNotHeldDisplaySizeMax: number;
  ordNotHeldIWPriceDisabled = false;
  ordNotHeldIWPriceValue: number;

  userContactNo: string;
  blockDeskContactTooltipMsg = '';

  priceRangeMessageTrailingStopPRC =
    "The stop parameter must be a whole number between 1 and 99.";
  priceInvalidMessage = "The value entered is not valid.";
  priceRangeMessage = "The value entered is not valid.";
  priceRangeMessageOther = "The value entered is not valid.";
  priceInvalidMessageTrailingStopPRC =
    "The stop parameter must be a whole number between 1 and 99.";
  priceInvalidMessageOther = "The value entered is not valid.";
  ordNotHeldPartRateInvalidMessage =
    "Participation rate must be a number between 1-80.";
  ordNotHeldMaxVolPctInvalidMessage = "Use a positive number between 1 and 99.";
  ordNotHeldMaxDispSizeInvalidMessage =
    "Display Size must be equal to or less than the order share quantity.";
  ordNotHeldIWPriceInvalidMessage =
    "Use a positive number with 0 to 2 decimal places.";
  expirationTypeInvalidMessage = "Expiration type is invalid";
  notHeldDestinationInvalidMessage = "Not held destination is invalid";
  notHeldAlgorithmInvalidMessage = "Not held algorithm is invalid";
  ordNotHeldFillPolicyInvalidMessage = "Not held fill policy is invalid";
  ordNotHeldStyleInvalidMessage = "Not held style is invalid";
  optionOrderTypeInvalidMessage = "Option order type is invalid";
  orderTypeInvalidMessage = "This value is required";
  mainPropertiesDisabled = false;
  globalSettings: IGlobalSettings;
  sameSymbol: boolean = false;
  stopPriceInvalidMessage = this.priceInvalidMessage;
  stopPriceInvalidMessageBuy = 'Limit Price must be above or equal to the Stop Price for a buy';
  stopPriceInvalidMessageSell = 'Limit Price must be below or equal to the Stop Price for a sell';
  isReplaceAction: boolean = false;
  enableFractionalShares:boolean=false;
  isFractionalSharesAllowed:boolean=false;
  filteredOrderTypes: Array<UIDropDownBlotter> = orderTypes;
  filteredExpTypes: Array<UIDropDownBlotter> = expTypes;
  isOption: boolean = false;
  private readonly fractionalShareHiddenExpTypeIds = ["DAYEXT", "GTDEXT", "EXTAM", "EXTPM"];
  private readonly marketOnCloseExpTypeIds = ["MOC", "Market On Close"];

  constructor(
    public util: UtilityService,
    private algorithmLayoutSetupSrv: AlgorithmLayoutSetup,
    private getDestinationQ: GetDestinationQ,
    private notHeldLayoutSetupSrv: NotHeldLayoutSetup,
    public spreadOptionActionSrv: SpreadOptionAction,
    private destinationInstructionSrv: DestinationInstruction,
    private trailingStopOrderTypeFilterSrv: TrailingStopOrderTypeFilter,
    public iss: IrbSettingsService,
    public as: AppService,    
  ) {
    this.enableFractionalShares = this.as.getItem('IRB_APP_CONFIG')?.featureFlags.ENABLE_FRACTIONAL_SHARES || false;
  }

  getAvailableExpirationTypes(
    sourceExpTypes: UIDropDownBlotter[] = expTypes,
    excludeMarketOnClose = false,
    applyFractionalLimitFilter =
      this.orderType === "LIMIT" &&
      this.data?.quantity !== undefined &&
      this.data?.quantity !== null &&
      this.data?.quantity !== "" &&
      !Number.isInteger(Number(this.data?.quantity))
  ): UIDropDownBlotter[] {
    let filteredExpTypes = [...(sourceExpTypes || [])];

    if (applyFractionalLimitFilter) {
      filteredExpTypes = filteredExpTypes.filter(
        (expType) => this.fractionalShareHiddenExpTypeIds.indexOf(expType.id) === -1
      );
    }

    if (excludeMarketOnClose) {
      filteredExpTypes = filteredExpTypes.filter(
        (expType) =>
          expType.name !== "MoC" &&
          this.marketOnCloseExpTypeIds.indexOf(expType.id) === -1 &&
          expType.value !== "Market On Close"
      );
    }

    return filteredExpTypes;
  }

  getDefaultExpirationType(
    sourceExpTypes: UIDropDownBlotter[] = this.expTypes,
    preferredExpTypeId = "DAY"
  ): UIDropDownBlotter {
    return (
      this.getFilteredValue(sourceExpTypes, "id", preferredExpTypeId) ||
      sourceExpTypes?.[0] ||
      null
    );
  }

  ngOnInit(): void {
    this.getPermissions();
    this.getGlobalSettings();
    const self = this;
    this.layoutFieldsShowHide = {} as iLayoutFieldsShowHide;
    this.tomorrowDate = this.getTomorrowDate();
    const d6m = this.util.incrementDays(new Date(), 179);
    this.daySixMonthsAfter = this.util.formatDateTimeString(d6m, "yyyy-MM-dd");
    this.daySixMonthsAfterDisplay = this.util.formatDateTimeString(d6m, "MM/dd/yyyy");

    if (this.data) {
      this.data = JSON.parse(JSON.stringify(this.data)); //its for a deep copy
      //console.log('data (original):', this.data);
      this.isReplaceAction = this.actionType === "Replace";

      if (this.actionType === "MultiEdit" && this.data.length) {
        this.multiRecords = JSON.parse(JSON.stringify(this.data)); //its for a deep copy
        this.data = JSON.parse(JSON.stringify(this.data[0])); //its for a deep copy
        for (let i = 0; i < this.multiRecords.length; i++) {
          const record = this.multiRecords[i];
          if (record.securityType && record.securityType?.toUpperCase() === 'OPTION') {
            this.optionRecordsPresent = true;
            break;
          }
        }
        let sameSymbol = true;
        const securitySymbol = this.multiRecords[0].securitySymbol;
        for (let i = 0; i < this.multiRecords.length; i++) {
          if (sameSymbol) {
            sameSymbol = securitySymbol === this.multiRecords[i].securitySymbol;
          }
        }
        this.sameSymbol = sameSymbol;
      } else {
        this.optionRecordsPresent = this.data?.securityType?.toUpperCase() === 'OPTION';
      }
      if (this.actionType === "MultiEdit") {
        this.data = itemsVariousVsValue(this.multiRecords, this);
      }
      //leave ALL CAPS for update
      this.data.orderStatus = formatOrderStatusReverse(this.data.orderStatus);
      this.data.orderType = formatOrderTypeReverse(this.data.orderType);
      this.data.expirationType = formatExpTypesReverse(
        this.data.expirationType
      );
      this.data.defaultOrderPriceType = formatdefaultOrderPriceTypeReverse(
        this.data.defaultOrderPriceType
      );
      this.data.transactionType = formatTransactionReverse(
        this.data.transactionType
      );
      this.data.notHeldAlgorithm = formatAlgorithmReverse(
        this.data.notHeldAlgorithm
      );
      this.data.securityType = formatSecurityTypeReverse(
        this.data.securityType
      );
      this.data.notHeldDestination = formatDestinationsReverse(
        this.data.notHeldDestination
      );

      if (this.actionType !== "MultiEdit" && !this.data.orderType) {
        // order type is n/a for Bonds, Mutual Funds, etc
        this.mainPropertiesDisabled = true;
      }
      this.pfs = this.parentObj.pfs;
      this.algorithmPermissionsObj.algorithmPermissionsList =
        this.parentObj.algorithmPermissionsList;
      // getMPIDQuotes(true); ???
      this.item = {}; // ?? dijit.byId(gridId).getItem(rowIndex);
      this.isParent = this.data.isBlockOrder;
      this.orderType = this.data.orderType;
      this.optionOrderType = this.data.optionOrderType;
      this.isShowMarketPrice = this.orderType === "MARKET";
      this.expirationDate =
        self.data.expirationDate && self.data.expirationDate > 0
          ? self.util.formatDateTimeString(
              new Date(self.data.expirationDate),
              "yyyy-MM-dd"
            )
          : null;

        // Determine filter function based on conditions
      this.isOption = this.data.securityType?.toUpperCase() === 'OPTION';
      const isFractional = this.data.quantity % 1 != 0;
      const isLessThanOne = this.data.quantity < 1;

      const getOrderTypeFilter = () => {
        if (this.isOption) {
          return () => true; // No filter for options
        } else if(isLessThanOne) {
          return (ot: any) => ot.id !== 'STOP' && ot.id !== 'STOPLIMIT' && ot.id !== 'LIMIT';
        } else if (isFractional) {
          return (ot: any) => ot.id !== 'STOP' && ot.id !== 'STOPLIMIT';
        }
        
        return () => true; // No filter
      };
      // Apply the filter to Expiration Types
      const orderTypeFilter = getOrderTypeFilter();
      this.filteredOrderTypes = orderTypes.filter(orderTypeFilter);
      //this.filteredExpTypes = expTypes.filter(this.expTypeFilter());

      // Get order type selected       
      this.orderTypeSelected = this.getFilteredValue(
         this.filteredOrderTypes,
        "id",
        this.orderType
      );
      // Set placeholder if orderTypeSelected is not found
      if (!this.orderTypeSelected) {
        this.orderTypeSelected = this.getFilteredValue(
          this.filteredOrderTypes,
          "id",
          this.orderType
        );
        this.orderTypePlaceHolder = this.getFilteredValue(
          this.filteredOrderTypes,
          "id",
          this.orderType
        );
        this.isOrderTypePlaceHolder = true;
      }

      this.expirationType = this.data.expirationType;
      this.expTypes = this.getAvailableExpirationTypes(
        expTypes,
        isFractional,
        this.orderType === "LIMIT" && !isFractional
      );
      this.expTypeSelected = this.getFilteredValue(
        this.expTypes,
        "id",
        this.expirationType
      );
      if (!this.expTypeSelected && (this.expirationType === 'MOC' || this.expirationType === 'Market On Close') && !isFractional) {
        this.expTypeSelected = this.getFilteredValue(
            this.expTypes,
            "name",
            'MoC'
        );
      }
      // use instead of typePriceObj
      this.priceType = this.data.defaultOrderPriceType;

      this.price = this.data.price;
      this.limitPrice = this.data.ordLimitPrice;
      if (this.data.orderType === "STOPLIMIT" && !this.data.ordLimitPrice) {
        this.limitPrice = this.data.price;
      }
      this.stopPrice = this.data.ordStopPrice;
      this.notHeld = this.data.ordIsNotHeld;

      this.ordNotHeldDisplaySizeMax = this.data.quantity;
      this.isSolicited = this.data.isSolicited;
      this.isDiscretionary = this.data.isDiscretionary;
      if (
        this.data.variousFields &&
        this.data.variousFields.indexOf("notHeldDestinations") !== -1
      ) {
        self.notHeldDestinationSelected = null;
      }
      this.notHeldLayoutSetup(false);
      if (
        self.data.notHeldDestination &&
        self.notHeldDestinationSelected === null
      ) {
        self.notHeldDestinations = self.algorithmPermissionsObj
          .algorithmPermissionsList
          ? self.getFilteredArray(
              getDestinations(
                self.algorithmPermissionsObj.algorithmPermissionsList
              ),
              "permissions",
              true
            )
          : [];
        self.notHeldDestinationSelected = self.getFilteredValue(
          self.notHeldDestinations,
          "id",
          self.data.notHeldDestination
        );
        if (self.notHeldDestinationSelected) {
          self.notHeldDestinationChanged({
            value: self.notHeldDestinationSelected,
          });
        }
        this.destinationLayoutSetup(self.data.notHeldDestination);
      }

      if (self.data.notHeldAlgorithm) {
        self.algorithmSelected = self.getFilteredValue(
          self.algorithms,
          "value",
          self.data.notHeldAlgorithm
        );
        this.algorithmLayoutSetup();
      }

      this.userContactNo = this.data.userContactNo;
      if (this.userContactNo) {
        this.userContactNo = this.userContactNo.toString();
      }
      this.ordNotHeldFillPolicySelected = this.getFilteredValue(
        this.ordNotHeldFillPolicys,
        "id",
        self.data.ordNotHeldFillPolicy
      );
      this.ordNotHeldIncludeExcludeSelected = this.getFilteredValue(
        this.ordNotHeldIncludeExclude,
        "id",
        (self.data.ordNotHeldInclude) ? "Include" : "Exclude"
      );
      this.ordNotHeldStyleSelected = this.getFilteredValue(
        this.ordNotHeldStyles,
        "id",
        self.data.ordNotHeldStyle
      );
      this.ordNotHeldAuctionOnly = self.data.ordNotHeldAuctionOnly || false;
      this.ordNotHeldStartTime = self.data.ordNotHeldStartTime;
      this.ordNotHeldEndTime = self.data.ordNotHeldEndTime;
      this.ordNotHeldPartRateValue = this.data.ordNotHeldPartRate;
      this.ordNotHeldMaxVolPctValue = this.data.ordNotHeldMaxVolPct;
      this.ordNotHeldMaxDispSizeValue = this.data.ordNotHeldMaxDispSize;
      this.ordNotHeldIWPriceValue = this.data.ordNotHeldIWPrice;

      this.setInitialValuesToPayload(this.pfs.updateOrderPayload.data, this);
      this.setInitialValuesToPayload(
        this.pfs.updateOrderPayload.prevData,
        this
      );
      if (this.userContactNo && this.userContactNo.length === 10) {
        this.userContactNo =
          this.userContactNo.substr(0, 3) +
          "-" +
          this.userContactNo.substr(3, 3) +
          "-" +
          this.userContactNo.substr(6);
      }
      if (this.actionType !== "MultiEdit") {
        this.pfs.updateOrderPayload.disableMode =
          this.data.orderStatus === "APPROVED" ||
          this.data.orderStatus === "WARNING" ||
          this.actionType === "Replace"
            ? false
            : true;
        this.changeOrderType =
          (this.data.ticketType === "E" ||
            this.data.ticketType === "ELECTRONIC") &&
          (this.data.orderStatus === "APPROVED" ||
            this.data.orderStatus === "WARNING") &&
          (this.data.securityType === "Equity" ||
            this.data.securityType === "EQUITY");
      } else {
        this.pfs.updateOrderPayload.disableMode = false;
        // this.item = {}; //IREBALUX-1213
      }
      this.item = this.data;
      this.priceTypeRadioDisplayHide(this.orderType, "onload");
      if (this.parentObj.current === "resolvedOrders" || this.parentObj.current === "automatedOrders") {
        this.pfs.updateOrderPayload.disableMode = true;
      }
      // todo: // todo: notHeldRefItm was used to capture chkbox val, Hari is checking if it's needed
      //if (Number(this.item.quantity) < 3000 && !this.pfs.updateOrderPayload.disableMode) { //TODO: change value from -1 to 3000.
      //   /*alert("Not-held orders can be used for equity orders exceeding 3,000 shares. They cannot be used for share quantities less than this amount.<br />"+
      //       "For more information, please contact the TD Ameritrade Institutional trading desk at 800-431-3500, option 1.");
      //       return false;*/
      //  this.notHeldRefItm = true;
      //}

      if (!this.pfs.updateOrderPayload.disableMode) {
        if (!this.notHeld) {
          this.notHeldDestinationSelected = null; //dijit.byId("notHeldDestination").set("value", "");

          //dijit.byId("notHeldDestination").set("disabled", true); //sa - hiding it instead

          this.layoutFieldsShowHide.algorithmDepFieldsLayDisplay = false; //dojo.byId("algorithmDepFieldsLay").style.display = "none";
          if (this.orderTypeSelected) {
            this.expirationTypeDisabled = false; // dijit.byId("expirationType").set("disabled", false);
          }
        }
      }

      if (this.actionType === "MultiEdit" && this.item.variousFields.length) {
        // dojo.forEach(dojo.query(".dijitError"), function (item) { //placeholders "Various"  for fields - done in templates
        // }
      } else {
        this.trailingStopOrderTypeFilter();
      }
      if (this.optionRecordsPresent) {
        //Defect #148469
        this.notHeldDisabled = true;
      }
      this.destinationInstruction("Landing");
      this.priceLabel =
        this.orderType === "TRAILING_STOP_PRC" ||
        this.orderType === "TRAILING_STOP_DOLLAR"
          ? this.orderType === "TRAILING_STOP_PRC"
            ? "Stop %"
            : "Stop $"
          : "Price";

      this.pfs.updateOrderPayload.tradeInstructionsRef = this;
      this.orderTypeChanged({ value: this.orderTypeSelected });
      this.optionOrderTypeSelected = this.getFilteredValue(this.optionOrderTypes, "id", this.optionOrderType);

      if(this.optionOrderTypeSelected) {
        this.optionOrderTypeChanged({ value: this.optionOrderTypeSelected });
      }
      
      const isSpreadTrade = this.data.securityType === "OPTION" && this.data.optionStrategyType === "SPREAD";

      if(!isSpreadTrade) {
        if (
          this.orderType !== "TRAILING_STOP_PRC" &&
          this.orderType !== "TRAILING_STOP_DOLLAR" &&
          this.orderType !== "STOP"
        ) {
          this.priceTypeChanged({
            value: { id: this.data.defaultOrderPriceType },
          });
        } else {
          this.price = this.data.price;
        }
      } else {
        this.price = (this.optionOrderType === "EVEN_MONEY") ? null : this.data.price;
      }

      this.pfs.updateOrderPayload.isModified = false;
    } else {
      this.pfs.updateOrderPayload = {} as UpdateOrderPayload;
    }
  }

  setInitialValuesToPayload(payloadObj: UpdateOrder, self: any) {
    payloadObj.orderID = self.data.orderID;
    payloadObj.versionId = self.data.versionId;
    payloadObj.orderAction = self.data.orderAction || null;
    payloadObj.orderStatus = formatOrderStatusReverse(self.data.orderStatus); // leave ALL CAPS for update
    payloadObj.ordIsNotHeld = self.data.ordIsNotHeld || false;
    payloadObj.orderType = formatOrderTypeReverse(self.data.orderType); // convert back to Title Case for update
    payloadObj.expirationType = formatExpTypesReverse(self.data.expirationType); // convert back to Title Case for update
    payloadObj.price = self.data.price;
    payloadObj.userContactNo = self.data.userContactNo;
    payloadObj.isSolicited = self.data.isSolicited;
    payloadObj.isDiscretionary = self.data.isDiscretionary;
    payloadObj.expirationDate = self.expirationDate;
    payloadObj.notHeldAlgorithm = self.data.notHeldAlgorithm;
    payloadObj.ordLimitPrice = self.limitPrice; // exception: self.data.ordLimitPrice sometimes incorrectly(?) has null
    payloadObj.ordStopPrice = self.data.ordStopPrice;
    payloadObj.defaultOrderPriceType = formatdefaultOrderPriceTypeReverse(
      self.data.defaultOrderPriceType
    );
    payloadObj.ordNotHeldFillPolicy = self.data.ordNotHeldFillPolicy;
    payloadObj.ordNotHeldInclude = self.data.ordNotHeldInclude;
    payloadObj.ordNotHeldStyle = self.data.ordNotHeldStyle;
    payloadObj.ordNotHeldStartTime = self.data.ordNotHeldStartTime;
    payloadObj.ordNotHeldEndTime = self.data.ordNotHeldEndTime;
    payloadObj.ordNotHeldPartRate = self.data.ordNotHeldPartRate;
    payloadObj.ordNotHeldMaxVolPct = self.data.ordNotHeldMaxVolPct;
    payloadObj.ordNotHeldMaxDispSize = self.data.ordNotHeldMaxDispSize;
    payloadObj.ordNotHeldIWPrice = self.data.ordNotHeldIWPrice;
    payloadObj.transactionType = formatTransactionReverse(
      self.data.transactionType
    ); // convert back to Title Case for update
    payloadObj.notHeldAlgorithm = formatAlgorithmReverse(
      self.data.notHeldAlgorithm
    ); // convert back to Title Case for update
    payloadObj.securityType = self.data.securityType;
    payloadObj.optionStrategyType = self.data.optionStrategyType;
    payloadObj.optionOrderType = self.data.optionOrderType;
  }

  getPermissions() {
    const self = this;
    self.notHeldPermissions = false;

    if (self.parentObj && self.parentObj.algorithmPermissionsList) {
      // This List for view/edit not held overlay.
      self.algorithmPermissionsObj.available = true;
      self.algorithmPermissionsObj.algorithmPermissionsList =
        self.parentObj.algorithmPermissionsList;

      Object.keys(
        self.algorithmPermissionsObj.algorithmPermissionsList
      ).forEach((key: string) => {
        if(!self.notHeldPermissions) {
          self.notHeldPermissions = self.algorithmPermissionsObj.algorithmPermissionsList[key];
        }
      });
    }
  }
  getGlobalSettings() {
    this.iss.getGlobalSettings().subscribe((data: IGlobalSettings) => {
      this.globalSettings = data as IGlobalSettings;
    });
  }
  //========================================
  // Event handlers
  //========================================

  // todo: todo: check w. Hari - implement
  // var widgets = dojo.query("[widgetId]", dojo.byId("viewEditTradeInsForm")).map(dijit.byNode);
  // dojo.forEach(widgets, function (w) {
  //   ctrl13 = dojo.connect(w, "onChange", function () {
  //     dijit.byId("viewEditSave").setAttribute("disabled", false);
  //     dijit.byId("viewEditReset").setAttribute("disabled", false);
  //   });
  // });

  notHeldChanged() {
    this.pfs.updateOrderPayload.data.ordIsNotHeld = this.notHeld;
    this.pfs.updateOrderPayload.isModified = true;
    this.layoutFieldsShowHide.destiDepField = false;
    this.layoutFieldsShowHide.blockDeskDepFieldsLay = false;
    this.layoutFieldsShowHide.algorithmDepFieldsLayDisplay = false;

    this.notHeldDestinationDisabled = !this.notHeld;

    /*
    TODO: Check with legacy
    if (target.classList.contains('multiEditCheckbox')) {
      target.classList.remove("multiEditCheckbox");
    }
    */
    this.ordIsNotHeldVarious = "";
    this.destinationInstructionText = "";
    const isSolicitedPrev = this.isSolicited;
    const isDiscretionaryPrev = this.isDiscretionary;
    if (!this.notHeld) {
      this.layoutFieldsShowHide.destiDepField = false;
      this.layoutFieldsShowHide.algorithmDepFieldsLayDisplay = false;
      this.layoutFieldsShowHide.blockDeskDepFieldsLay = false;

      if (this.globalSettings) {
        this.isSolicited = this.globalSettings.isSolicited || false;
        this.isDiscretionary = this.globalSettings.isDiscretionary || false;
      }
    } else {
      this.isSolicited = false;
      this.isDiscretionary = true;
      this.isSolictedVarious = false;
      this.isDiscretionaryVarious = false;
    }
    if (this.isSolicited !== isSolicitedPrev) {
      this.authSolicitedChanged();
    }
    if (this.isDiscretionary !== isDiscretionaryPrev) {
      this.authDiscretionaryChanged();
    }
    // IREBAL-29440 - Remove 3k share qty threshold to make algos available in multi order edit trade instructions
    // if (this.actionType === "MultiEdit" && this.notHeld) {
    //   const shareBool = this.data.quantity > 3000;
    //   this.notHeldLayoutSetup(!shareBool);
    // } else if (!this.notHeld) {
    //   this.notHeldLayoutSetup(false);
    // } else {
    //   this.notHeldLayoutSetup(false);
    // }
    this.notHeldLayoutSetup(false);
    if (this.notHeldDestinationElem) {
      this.notHeldDestinationElem.value = this.notHeldDestinationSelected;
    }
  }
  notHeldVariousClicked() {
    this.isShowNotHeldVarious = false;
    this.notHeld = true;
    this.notHeldChanged();
  }
  solicitedVariousClicked() {
    this.isSolictedVarious = false;
    this.isSolicited = true;
    this.authSolicitedChanged();
  }
  discretionaryVariousClicked() {
    this.isDiscretionaryVarious = false;
    this.isDiscretionary = true;
    this.authDiscretionaryChanged();
  }
  authSolicitedChanged() {
    this.isSolictedVarious = false;
    this.pfs.updateOrderPayload.data.isSolicited = this.isSolicited;
    this.pfs.updateOrderPayload.isModified = true;
  }
  authDiscretionaryChanged() {
    this.isDiscretionaryVarious = false;
    this.pfs.updateOrderPayload.data.isDiscretionary = this.isDiscretionary;
    this.pfs.updateOrderPayload.isModified = true;
  }

  getAlgorithms(searchStr: string) {
    this.algorithmTapped();
    let a = DropdownFilterComponent.getFilteredList(searchStr, this.algorithms.sort((a, b) => a.name.localeCompare(b.name)))
    a = this.util.sortByKey(a, "name", "asc");
    this.notHeldAlgorithmElem.set(a);  }

  algorithmChanged(event: any) {
    this.clearAlgorithmFields();
    this.algorithmLayoutSetup();
    const algValue =
      event.value && event.value.id ? event.value.id : event.value;
    this.pfs.updateOrderPayload.data.notHeldAlgorithm = algValue;
    this.pfs.updateOrderPayload.isModified = true;

    //setTimeout(() => {
      this.pfs.updateOrderPayload.isValid();
    //});
  }

  clearAlgorithmFields() {
    this.userContactNo = "";
    this.ordNotHeldFillPolicySelected = null;
    this.ordNotHeldStartTime = null;
    this.ordNotHeldEndTime = null;
    this.ordNotHeldIncludeExcludeSelected = null;
    this.ordNotHeldMaxVolPctValue = null;
    this.ordNotHeldMaxDispSizeValue = null;
    this.ordNotHeldStyleSelected = null;
    this.ordNotHeldIWPriceValue = null;
  }

  algorithmTapped() {
    //false && console.log(event);
    this.notHeldAlgorithmTooltipMsg = "";
    //this.notHeldAlgorithmElem.styleClass = '';
    if (this.notHeldAlgorithmElem && this.notHeldAlgorithmElem.input) {
      this.notHeldAlgorithmElem.input.nativeElement.classList.remove(
        "ng-invalid"
      );
    }
  }

  getNotHeldDestinations(searchStr: string) {
    this.notHeldDestinationTapped();
    let a = DropdownFilterComponent.getFilteredList(searchStr, this.notHeldDestinations.sort((a, b) => a.name.localeCompare(b.name)));
    a = this.util.sortByKey(a, "name", "asc");
    this.notHeldDestinationElem.set(a);  }
  notHeldDestinationChanged(event: any) {
    const self = this;
    let value = event.value && event.value.id ? event.value.id : event.value;
    this.destinationLayoutSetup(value);
    self.pfs.updateOrderPayload.data.notHeldDestination = value || null;
    self.pfs.updateOrderPayload.data.expirationType =
      self.expirationType || null;
    self.pfs.updateOrderPayload.isModified = true;
  }

  notHeldDestinationTapped() {
    // false && console.log(event);
    this.notHeldDestinationTooltipMsg = "";
    //this.notHeldDestinationElem.styleClass = '';
    if (this.notHeldDestinationElem && this.notHeldDestinationElem.input) {
      this.notHeldDestinationElem.input.nativeElement.classList.remove(
        "ng-invalid"
      );
    }
  }

  destinationLayoutSetup(value: any) {
    const self = this;
    self.notHeldDestinationSelected = self.getFilteredValue(
      self.notHeldDestinations,
      "id",
      value
    );
    if (self.notHeldDestinationElem) {
      self.notHeldDestinationElem.value = self.notHeldDestinationSelected;
    }
    self.algorithmSelected = null;
    self.algorithmEnabled = false;
    self.layoutFieldsShowHide.destiDepField = false;
    self.layoutFieldsShowHide.blockDeskDepFieldsLay = false;
    self.layoutFieldsShowHide.algorithmDepFieldsLayDisplay = false;
    self.orderTypes = self.getFilteredArray(
      orderTypes,
      "trailingStopAvailable",
      "TRUE"
    );
    if (value === "VIRTU" || value === "CITADEL") {
      //self.orderTypes = self.getFilteredArray(orderTypes, 'destType', 'ARRIVAL');
      if (self.orderType !== "LIMIT" && self.orderType !== "MARKET") {
        self.pfs.updateOrderPayload.data.orderType = null;
      }
      self.expirationDateDisabled = true;
      self.expirationDate = null;
      self.expirationTypeDisabled = true;
      self.expTypeSelected = null;
      self.destinationInstruction();
    }

    if (value === "CITADEL") {
      // dojo.byId("destiDepField").style.display = "inline-table"; // == algorithm DD
      self.layoutFieldsShowHide.destiDepField = true;
      self.algorithms = self.getFilteredArray(getAlgorithms(self.algorithmPermissionsObj.algorithmPermissionsList), "permissions", true);
      self.algorithms = self.getFilteredArray(self.algorithms, "citadel", true);
      //self.algorithmSelected = null;
    } else if (value === "VIRTU") {
      self.layoutFieldsShowHide.destiDepField = true;

      self.algorithms = self.getFilteredArray(
        getAlgorithms(self.algorithmPermissionsObj.algorithmPermissionsList),
        "permissions",
        true
      );
      self.algorithms = self.getFilteredArray(self.algorithms, "virtu", true);
      //self.algorithmSelected = null;
    } else if (value === "AOM_PRINTER") {
      self.orderTypes = self.getFilteredArray(
        orderTypes,
        "destType",
        "ORDERTYPEONLY"
      );
      //self.orderTypes = orderTypes.slice(0,1);
      self.setDestination();
      self.layoutFieldsShowHide.destiDepField = false;
      self.layoutFieldsShowHide.blockDeskDepFieldsLay = true;
      self.expirationTypeDisabled = true;
      if (
        self.data.variousFields &&
        self.data.variousFields.indexOf("expirationType") > -1
      ) {
        self.expTypeSelected = null;
        self.expirationType = null;
      } else {
        const defaultExpType = self.getDefaultExpirationType(
          self.getAvailableExpirationTypes(expTypes),
          "DAY"
        );
        self.expTypeSelected = defaultExpType;
        self.expirationType = defaultExpType ? defaultExpType.id : null;
      }
      
      self.userContactNo = self.parentObj.envLastUsedContactNo;
      self.blockDeskContactChanged({ target: { value: self.userContactNo } });
      const orderTypeSelectedPrev = self.orderTypeSelected
        ? self.orderTypeSelected.id
        : "";
      self.destinationInstruction();
      self.orderTypeSelected = self.getFilteredValue(
        orderTypes,
        "id",
        "MARKET"
      );
      if (self.orderTypeElem) {
        self.orderTypeElem.value = self.orderTypeSelected;
      }
      if (self.orderTypeSelected.id !== orderTypeSelectedPrev) {
        self.orderTypeChanged({
          value: self.orderTypeSelected,
          from: "destinationLayoutSetup",
        });
      }
    }
    if (self.actionType === "MultiEdit") {
      // dijit.byId('orderType').query = { // done see ==> this.setDestination(value)
      //   destType: getDestinationQ()
      // }; //IREBALUX-1507 - Prevent Limit Orders when Destination is Set to Block Desk
      self.setDestination();
    }
    if (self.notHeldAlgorithmElem) {
      self.notHeldAlgorithmElem.value = self.algorithmSelected;
    }
  }

  // viewEditResetClicked(event: any) { //todo: todo: check w. Hari - implement
  //   false && console.log('viewEditResetClicked', event);
  // }

  getOrderTypes(searchStr: string) {
    this.orderTypeTapped();
    this.orderTypeElem.set(DropdownFilterComponent.getFilteredList(searchStr, this.filteredOrderTypes));
  }
  orderTypeChanged(event: any) {
    // this.csOrderblotter('etiordertype'); // todo: implement - clickStream analytics
    //this.isModified = false;
    if (event.value) {
      this.orderTypeRemainsVarious = false;
      const val = event.value.id || event.value;
      this.orderType = val;
      // this.orderTypeSelected = this.getFilteredValue(orderTypes, 'id', val);
      this.pfs.updateOrderPayload.data.orderType = val;
      if (
        this.pfs.updateOrderPayload.data.orderType !==
          this.pfs.updateOrderPayload.prevData.orderType ||
        this.pfs.updateOrderPayload.data.expirationType !==
          this.pfs.updateOrderPayload.prevData.expirationType
      ) {
        this.pfs.updateOrderPayload.isModified = true;
        this.orderTypeLayoutSetup(true);
      } else {
        this.orderTypeLayoutSetup(false);
      }

      if (event.originalEvent) {
        this.price = null;
        this.stopPrice = null;
        this.limitPrice = null;
        this.priceType = "None";
        this.priceTypeSelected = this.getFilteredValue(
          priceTypes,
          "id",
          this.priceType
        );
      }
    } else {
      this.orderType = "";
    }
    // this.expTypes has already been updated by orderTypeLayoutSetup to only contain
    // the valid expiration types for the current order type, so search within it to
    // avoid retaining a selection that belongs to a different order type (e.g. Day Ext
    // being kept when switching from Limit → Market).
    this.expTypeSelected = this.getFilteredValue(
      this.expTypes,
      "id",
      this.expirationType
    );
    if (this.expirationTypeElem) {
      this.expirationTypeElem.value = this.expTypeSelected;
    }

    /*
     * IREBALUX-3484 & IREBALUX-3342
     * Not Held Order Destinations and Available Order Types
     */
    if (event.from && event.from === "destinationLayoutSetup") {
    } else {
      this.destinationInstruction();
    }
    
    this.spreadOptionAction(this.orderType);
    this.isShowMarketPrice = this.orderType === "MARKET";
  }

  orderTypeTapped() {
    this.orderTypeTooltipMsg = "";
    //this.orderTypeElem.styleClass = '';
    if (this.orderTypeElem.input) {
      this.orderTypeElem.input.nativeElement.classList.remove("ng-invalid");
    }
  }

  setMultiEditPrice() {
    this.isShowPriceVarious = false;
    this.limitPrice = null;
  }

  getOptionOrderTypes(searchStr: string) {
     this.optionOrderTypeTapped();
    this.optionOrderTypeElem.set(DropdownFilterComponent.getFilteredList(searchStr, this.optionOrderTypes));
  }

  optionOrderTypeChanged(event: any) {
    const val = event.value.id || event.value;
    this.pfs.updateOrderPayload.data.optionOrderType = val;
    this.pfs.updateOrderPayload.isModified = true;
    this.spreadOptionAction("priceField", val);
    if (this.optionOrderTypeElem) {
      this.optionOrderTypeElem.value = this.optionOrderTypeSelected;
    }
  }

  optionOrderTypeTapped() {
    //false && console.log(event);
    this.optionOrderTypeTooltipMsg = "";
    //this.optionOrderTypeElem.styleClass = '';
    if (this.optionOrderTypeElem.input) {
      this.optionOrderTypeElem.input.nativeElement.classList.remove(
        "ng-invalid"
      );
    }
  }

  onPriceChange(event: any) {
    if (event.target) {
      if (event.target.classList.contains("ng-invalid")) {
        this.pfs.updateOrderPayload.validator.priceValid = false;
      } else {
        this.pfs.updateOrderPayload.validator.priceValid = true;
      }
      this.pfs.updateOrderPayload.data.price = this.price;
      if (this.price !== this.data.price) {
        this.pfs.updateOrderPayload.isModified = true;
      }
    }
  }
  onLimitPriceChange(event: any) {
    // todo: implement if needed or remove
    if (event.target) {
      if (event.target.classList.contains("ng-invalid")) {
        this.pfs.updateOrderPayload.validator.ordLimitPriceValid = false;
      } else {
        this.pfs.updateOrderPayload.validator.ordLimitPriceValid = true;
      }
      this.pfs.updateOrderPayload.data.ordLimitPrice = this.limitPrice;
      if (
        this.pfs.updateOrderPayload.data.ordLimitPrice !==
        this.pfs.updateOrderPayload.prevData.ordLimitPrice
      ) {
        this.pfs.updateOrderPayload.isModified = true;
      }
      if (this.orderTypeSelected.id === 'STOPLIMIT') {
        this.pfs.updateOrderPayload.validateStopPrice();
        if (this.pfs.updateOrderPayload.validator.ordStopPriceValid) {
          this.stopPriceElem.tooltipMessage = '';
          this.stopPriceElem.inputField.nativeElement.classList.remove('ng-invalid');
          this.stopPriceElem.inputField.nativeElement.classList.add('ng-valid');
        } else {
          this.stopPriceElem.tooltipMessage = this.stopPriceInvalidMessage;
          this.stopPriceElem.inputField.nativeElement.classList.remove('ng-valid');
          this.stopPriceElem.inputField.nativeElement.classList.add('ng-invalid');
        }
      }
    }
  }

  onStopPriceChange(event: any) {
    if (event.target) {

      // if (event.target.classList.contains('ng-invalid')) {
      //   this.pfs.updateOrderPayload.validator.ordStopPriceValid = false;
      // } else {
      //   this.pfs.updateOrderPayload.validator.ordStopPriceValid = true;
      // }
      this.pfs.updateOrderPayload.data.ordStopPrice = this.stopPrice;
      if (this.stopPrice !== this.data.ordStopPrice) {
        this.pfs.updateOrderPayload.isModified = true;
      }
      this.pfs.updateOrderPayload.validateStopPrice();
      if (this.stopPriceElem) {
        if (this.pfs.updateOrderPayload.validator.ordStopPriceValid) {
          this.stopPriceElem.tooltipMessage = '';
          this.stopPriceElem.inputField.nativeElement.classList.remove('ng-invalid');
          this.stopPriceElem.inputField.nativeElement.classList.add('ng-valid');
        } else {
          this.stopPriceElem.tooltipMessage = this.stopPriceInvalidMessage;
          this.stopPriceElem.inputField.nativeElement.classList.remove('ng-valid');
          this.stopPriceElem.inputField.nativeElement.classList.add('ng-invalid');
        }
      }

    }
  }
  onPriceTapped(event: any) {
    if (event.target) {
      // event.target.classList.remove('ng-invalid');
      this.pfs.updateOrderPayload.validator.priceValid = true;
    }
    this.isShowPriceVarious = false;
  }
  onLimitPriceTapped(event: any) {
    if (event.target) {
      //event.target.classList.remove('ng-invalid');
      this.pfs.updateOrderPayload.validator.ordLimitPriceValid = true;
      if (this.orderTypeSelected.id === 'STOPLIMIT') {
        this.pfs.updateOrderPayload.validator.ordStopPriceValid = true;
        if (this.stopPriceElem) {
          this.stopPriceElem.inputField.nativeElement.classList.remove('ng-invalid');
          this.stopPriceElem.inputField.nativeElement.classList.add('ng-valid');
        }
      }
    }
    this.isShowLimitPriceVarious = false;
  }
  onStopPriceTapped(event: any) {
    if (event.target) {
      this.pfs.updateOrderPayload.validator.ordStopPriceValid = true;
      if (this.stopPriceElem) {
        this.stopPriceElem.inputField.nativeElement.classList.remove('ng-invalid');
        this.stopPriceElem.inputField.nativeElement.classList.add('ng-valid');
        this.stopPriceElem.tooltipMessage = '';
      }
    }
    this.isShowStopPriceVarious = false;
  }

  getExpTypes(searchStr: string) {
    this.expirationTypeTapped();
    this.expirationTypeElem.set(DropdownFilterComponent.getFilteredList(searchStr, this.expTypes));
  }
  expirationTypeChanged(event: any) {
    this.expirationType = event.value.id || event.value;
    //false && console.log('expirationTypeChanged', event, this.expirationType);
    this.expirationDateDisabled =
      this.expirationType &&
      !(this.expirationType === "GTD" || this.expirationType === "GTDEXT");
    if (!this.expirationDateDisabled) {
      this.tomorrowDate = this.getTomorrowDate();
    }
    this.pfs.updateOrderPayload.data.expirationType =
      this.expirationType || null;
    this.pfs.updateOrderPayload.isModified = true;
  }
  getTomorrowDate() {
    return this.util.formatDateTimeString(
      this.util.incrementDays(new Date(), 1),
      "yyyy-MM-dd"
    );
  }
  expirationTypeTapped() {
    //false && console.log(event);
    this.expirationTypeTooltipMsg = "";
    //this.expirationTypeElem.styleClass = '';
    if (this.expirationTypeElem.input) {
      this.expirationTypeElem.input.nativeElement.classList.remove(
        "ng-invalid"
      );
    }
  }
  expirationDateChanged(event: any) {
    this.expirationDate = event.target.value;
    this.pfs.updateOrderPayload.data.expirationDate =
      this.expirationDate || null;
    this.pfs.updateOrderPayload.isModified = true;
  }
  expirationDateTapped(event: any) {
    false && console.log(event);
    this.expirationDateTooltipMsg = "";
    this.expirationDateElem.nativeElement.classList.remove("ng-invalid");
    this.expirationDateElem.nativeElement.classList.add("ng-valid");
  }
  blockDeskContactChanged(event: any) {
    this.userContactNo = event.target.value;
    if (this.userContactNo) {
      this.userContactNo = this.userContactNo.toString().replace(/-/g, "");
    }

    this.pfs.updateOrderPayload.data.userContactNo = this.userContactNo || null;
    this.pfs.updateOrderPayload.isModified = true;
    if (this.userContactNo && this.userContactNo.length === 10) {
      this.userContactNo =
        this.userContactNo.substr(0, 3) +
        "-" +
        this.userContactNo.substr(3, 3) +
        "-" +
        this.userContactNo.substr(6);
    }
  }
  blockDeskContactTapped(event: any) {
    false && console.log(event);
    this.blockDeskContactTooltipMsg = "";
    this.blockDeskContact.nativeElement.classList.remove("ng-invalid");
    this.blockDeskContact.nativeElement.classList.add("ng-valid");
  }

  getPriceTypes(searchStr: string) {
    this.priceTypesElem.set(DropdownFilterComponent.getFilteredList(searchStr, this.priceTypes));
  }
  priceTypeChanged(event: any) {
    const self = this;
    self.priceType = event.value.id || event.value;
    self.priceTypeSelected = self.getFilteredValue(
      priceTypes,
      "id",
      self.priceType
    );
    self.priceDisabled = !(
      !self.priceTypeSelected ||
      (self.priceTypeSelected && self.priceTypeSelected.id === "None")
    );
    if (self.priceTypeSelected) {
      if (
        self.actionType === "MultiEdit" &&
        self.data.securitySymbolFilteredVarious
      ) {
        self.isShowPriceVarious = true;
      }
      if (self.priceTypeSelected.id === "None") {
        if (event.originalEvent) {
          self.price = null;
        }
      }
      if (self.priceTypeSelected.id === "BID") {
        self.price = self.bidAndAskPrices ? self.bidAndAskPrices.bid : null;
      }
      if (self.priceTypeSelected.id === "ASK") {
        self.price = self.bidAndAskPrices ? self.bidAndAskPrices.ask : null;
      }
      if (self.priceTypeSelected.id === "LASTTRADE") {
        self.price = self.bidAndAskPrices
          ? self.bidAndAskPrices.lastPrice
          : null;
      }
      if (self.priceTypeSelected.id === "MIDPOINT") {
        self.price = self.bidAndAskPrices
          ? self.bidAndAskPrices.midpoint
          : null;
      }
      self.pfs.updateOrderPayload.data.price = self.price;
      self.pfs.updateOrderPayload.data.defaultOrderPriceType =
        self.priceTypeSelected.id;
      self.pfs.updateOrderPayload.isModified = true;
    }
    //false && console.log('priceTypeChanged', event);
  }

  getOrdNotHeldFillPolicys(searchStr: string) {
    this.ordNotHeldFillPolicyTapped();
    this.ordNotHeldFillPolicyElem.set(DropdownFilterComponent.getFilteredList(searchStr, this.ordNotHeldFillPolicys));
  }
  ordNotHeldFillPolicyChanged(event: any) {
    const self = this;
    const value = event.value.id || event.value;
    self.ordNotHeldFillPolicySelected = self.getFilteredValue(
      self.ordNotHeldFillPolicys,
      "id",
      value
    );
    self.pfs.updateOrderPayload.data.ordNotHeldFillPolicy = value || null;
    self.pfs.updateOrderPayload.isModified = true;
  }

  ordNotHeldFillPolicyTapped() {
    //false && console.log(event);
    this.ordNotHeldFillPolicyTooltipMsg = "";
    //this.ordNotHeldFillPolicyElem.styleClass = '';
    if (this.ordNotHeldFillPolicyElem) {
      if (this.ordNotHeldFillPolicyElem.input) {
        this.ordNotHeldFillPolicyElem.input.nativeElement.classList.remove(
          "ng-invalid"
        );
      }
    }
  }

  getOrdNotHeldIncludeExclude(searchStr: string) {
    this.includeExcudeElem.set(DropdownFilterComponent.getFilteredList(searchStr, this.ordNotHeldIncludeExclude));
  }
  ordNotHeldIncludeExcludeChanged(event: any) {
    const self = this;
    const value = event.value.id || event.value;
    self.ordNotHeldIncludeExcludeSelected = self.getFilteredValue(
      self.ordNotHeldIncludeExclude,
      "id",
      value
    );
    self.pfs.updateOrderPayload.data.ordNotHeldInclude = value || null;
    self.pfs.updateOrderPayload.isModified = true;
  }

  ordNotHeldStyleChanged(event: any) {
    const self = this;
    const value = event.value.id || event.value;
    self.ordNotHeldStyleSelected = self.getFilteredValue(
      self.ordNotHeldStyles,
      "id",
      value
    );
    if (self.pfs.updateOrderPayload && self.pfs.updateOrderPayload.data) {
      // prevents test failing
      self.pfs.updateOrderPayload.data.ordNotHeldStyle = value || null;
      self.pfs.updateOrderPayload.isModified = true;
    }
  }

  getOrdNotHeldStyles(searchStr: string) {
    this.ordNotHeldStyleTapped();
    this.ordNotHeldStyleElem.set(DropdownFilterComponent.getFilteredList(searchStr, this.ordNotHeldStyles));
  }

  ordNotHeldStyleTapped() {
    //false && console.log(event);
    this.ordNotHeldStyleTooltipMsg = "";
    if (this.ordNotHeldStyleElem) {
      //this.ordNotHeldStyleElem.styleClass = '';
      if (this.ordNotHeldStyleElem.input) {
        this.ordNotHeldStyleElem.input.nativeElement.classList.remove(
          "ng-invalid"
        );
      }
    }
  }
  ordNotHeldStartTimeChanged(event: any) {
    const self = this;
    const value = event.target.value;
    self.pfs.updateOrderPayload.data.ordNotHeldStartTime = value || null;
    self.pfs.updateOrderPayload.isModified = true;
  }
  ordNotHeldStartTimeTapped(event: any) {
    false && console.log(event);
    this.ordNotHeldStartTimeTooltipMsg = "";
    this.ordNotHeldStartTimeElem.nativeElement.classList.remove("ng-invalid");
    this.ordNotHeldStartTimeElem.nativeElement.classList.add("ng-valid");
  }
  ordNotHeldEndTimeChanged(event: any) {
    const self = this;
    const value = event.target.value;
    self.pfs.updateOrderPayload.data.ordNotHeldEndTime = value || null;
    self.pfs.updateOrderPayload.isModified = true;
  }
  ordNotHeldEndTimeTapped(event: any) {
    false && console.log(event);
    this.ordNotHeldEndTimeTooltipMsg = "";
    this.ordNotHeldEndTimeElem.nativeElement.classList.remove("ng-invalid");
    this.ordNotHeldEndTimeElem.nativeElement.classList.add("ng-valid");
  }

  ordNotHeldAuctionOnlyChanged(event: any) {
    const self = this;
    self.pfs.updateOrderPayload.data.ordNotHeldAuctionOnly = event.checked;
    self.pfs.updateOrderPayload.isModified = true;
  }

  //todo: implement
  onOrdNotHeldPartRateChanged(event: any) {
    const self = this;
    if (event.target) {
      if (event.target.classList.contains("ng-invalid")) {
        self.pfs.updateOrderPayload.validator.ordNotHeldPartRateValid = false;
      } else {
        self.pfs.updateOrderPayload.validator.ordNotHeldPartRateValid = true;
      }
      self.pfs.updateOrderPayload.data.ordNotHeldPartRate = this.ordNotHeldPartRateValue;
      self.pfs.updateOrderPayload.isModified = true;
    }
  }
  ordNotHeldMaxVolPctChanged(event: any) {
    const self = this;
    if (event.target) {
      if (event.target.classList.contains("ng-invalid")) {
        self.pfs.updateOrderPayload.validator.ordNotHeldMaxVolPctValid = false;
      } else {
        self.pfs.updateOrderPayload.validator.ordNotHeldMaxVolPctValid = true;
      }
      self.pfs.updateOrderPayload.data.ordNotHeldMaxVolPct = this.ordNotHeldMaxVolPctValue;
      self.pfs.updateOrderPayload.isModified = true;
    }
  }
  ordNotHeldMaxDispSizeChanged(event: any) {
    const self = this;
    if (event.target) {
      if (event.target.classList.contains("ng-invalid")) {
        self.pfs.updateOrderPayload.validator.ordNotHeldMaxVolPctValid = false;
      } else {
        self.pfs.updateOrderPayload.validator.ordNotHeldMaxVolPctValid = true;
      }
      self.pfs.updateOrderPayload.data.ordNotHeldMaxDispSize = this.ordNotHeldMaxDispSizeValue;
      self.pfs.updateOrderPayload.isModified = true;
    }
  }
  ordNotHeldIWPriceChanged(event: any) {
    const self = this;
    if (event.target) {
      if (event.target.classList.contains("ng-invalid")) {
        self.pfs.updateOrderPayload.validator.ordNotHeldMaxVolPctValid = false;
      } else {
        self.pfs.updateOrderPayload.validator.ordNotHeldMaxVolPctValid = true;
      }

      self.pfs.updateOrderPayload.data.ordNotHeldIWPrice = this.ordNotHeldIWPriceValue;
      self.pfs.updateOrderPayload.isModified = true;
    }
  }

  //===========================
  // Filters for drop-down data
  //===========================
  getFilteredValue(
    arr: UIDropDownBlotter[],
    key: keyof UIDropDownBlotter,
    value: any
  ) {
    if (!arr) {
      arr = [];
    }
    const selected = arr.filter((e) => {
      if (Array.isArray(e[key])) {
        const a = e[key] as Array<any>;
        return a.indexOf(value) !== -1 || a.length === 0;
      }
      return e[key] === value;
    });
    if (selected.length > 0) {
      return selected[0];
    } else {
      return null;
    }
  }
  getFilteredArray(
    arr: UIDropDownBlotter[],
    key: keyof UIDropDownBlotter,
    value: any
  ) {
    const selected = arr.filter((e) => {
      if (Array.isArray(e[key])) {
        const a = e[key] as Array<any>;
        return a.indexOf(value) !== -1 || a.length === 0;
      } else {
        return true;
      }
    });
    return selected;
  }

  //===================================================
  // main logic
  //===================================================
  algorithmLayoutSetup() {
    this.algorithmLayoutSetupSrv.algorithmLayoutSetup(this);
  }
  setDestination() {
    this.getDestinationQ.setDestination(this);
  }

  notHeldLayoutSetup(shrCnty: boolean) {
    this.notHeldLayoutSetupSrv.notHeldLayoutSetup(shrCnty, this);
  }
  spreadOptionAction(action: any, response?: any) {
    // todo: implement (continue)
    return this.spreadOptionActionSrv.spreadOptionAction(
      action,
      this,
      response
    );
  }

  orderTypeLayoutSetup(expirationBoolean: boolean) {
    orderTypeLayoutSetup(expirationBoolean, this);
  }

  priceTypeRadioDisplayHide(orderType: string, callingFrom: string) {
    const self = this;
    const isSpreadTrade = this.data.securityType === "OPTION" && this.data.optionStrategyType === "SPREAD";
    const displayShowHide = orderType === "LIMIT" && !isSpreadTrade;
    
    self.priceTypeVisible = displayShowHide;
    if (callingFrom === "orderddfun" && !displayShowHide) {
      self.priceType = "None";
      self.price = null;
    }
  }

  expirationDateToggle(val: string, item: any) {
    const a =
      (val === "GTD" || val === "GTDEXT") &&
      (this.changeOrderType ||
        this.actionType === "Replace" ||
        this.actionType === "MultiEdit");
    const b = val === "GTD" && item.securityType === "OPTION";

    if (a || b) {
      this.expirationDateDisabled = false;
      // if (dijit.byId("expirationDate").getDisplayedValue() == "n/a") { // todo: implement if new design needs it
      //   dijit.byId("expirationDate").setDisplayedValue("");
      // }
    } else {
      this.expirationDateDisabled = true;
      this.expirationDate = null;
      //dijit.byId("expirationDate").setDisplayedValue("n/a");
    }
  }

  destinationInstruction(caseValue?: any) {
    this.destinationInstructionSrv.destinationInstruction(caseValue, this);
  }
  trailingStopOrderTypeFilter() {
    this.trailingStopOrderTypeFilterSrv.trailingStopOrderTypeFilter(this);
    if (this.orderTypeElem) {
      this.orderTypeElem.value = this.orderTypeSelected;
    }
  }
  formatCurrency(c: number) {
    return formatCurrency(c, "EN-US", "$");
  }
}
